import {
  useMutation,
  type QueryKey,
  type UseMutationOptions,
  type UseMutationResult,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { api } from '@/utils/api';
import { ApiErrorResponse, ApiResponse } from '@/types/api';
import { UserInfo } from '@/types/user';

export interface SignUpRequest {
  name: string;
  password: string;
  email: string;
  company: string;
  phone: string;
  position: string;
  isMarketingPolicyAccepted: boolean;
  acquisitionPath: string;
}

export interface SignUpResponse {
  user: UserInfo;
}

export const signUp = ({
  name,
  password,
  email,
  company,
  phone,
  position,
  isMarketingPolicyAccepted,
  acquisitionPath,
}: SignUpRequest) => {
  return api.post<ApiResponse<SignUpResponse>>('/auth/signup', {
    name,
    password,
    email,
    company,
    phone,
    position,
    isMarketingPolicyAccepted,
    acquisitionPath,
  });
};

const useSignUp = <TError = AxiosError<ApiErrorResponse>>(
  options?: UseMutationOptions<
    AxiosResponse<ApiResponse<SignUpResponse>>,
    TError,
    SignUpRequest,
    QueryKey
  >,
): UseMutationResult<
  AxiosResponse<ApiResponse<SignUpResponse>>,
  TError,
  SignUpRequest,
  QueryKey
> => {
  return useMutation(signUp, {
    ...options,
  });
};

export default useSignUp;
